export default  {
    'SignIn': {path:'/user-micro/user-end/auth/sign-in/wx',method: 'post'},
    'GetInfo': {path:'/user-micro/user-end/user/info',method: 'get'},
    'GetWechatConfig':{path:'/wx-micro/wx-config/js',method: 'post'},
    'UpdateUserInfo': { path: 'user-micro/user-end/user/info', method: 'put'},

    'CreateRegistration': { path: 'user-micro/user-end/registrations',method: 'post'},
    'GetRegistrationList': { path: 'user-micro/user-end/registrations/get',method: 'post'},
    'DeleteRegistration': { path: 'user-micro/user-end/registrations/:ID', method: 'delete'},
    'UpdateRegistration': { path: 'user-micro/user-end/registrations', method: 'put'},

    'CreateCreditInfo': { path: 'user-micro/user-end/credit-info',method: 'post'},
    'GetCreditInfoList': { path: 'user-micro/user-end/credit-info/get',method: 'post'},
    'DeleteCreditInfo': { path: 'user-micro/user-end/credit-info/:ID', method: 'delete'},
    'UpdateCreditInfo': { path: 'user-micro/user-end/credit-info', method: 'put'},

    'CreateInvoiceInfo': { path: 'user-micro/user-end/invoice-info',method: 'post'},
    'GetInvoiceInfoList': { path: 'user-micro/user-end/invoice-info/get',method: 'post'},
    'DeleteInvoiceInfo': { path: 'user-micro/user-end/invoice-info/:ID', method: 'delete'},
    'UpdateInvoiceInfo': { path: 'user-micro/user-end/invoice-info', method: 'put'},


    'SearchMemberCompany' : { path: 'order-micro/user-end/member-company/search',method: 'post'},

    'GetMeetingList': { path: 'meeting-micro/user-end/meeting/get',method: 'post'},
    'SearchMeeting' : { path: 'meeting-micro/user-end/meeting/search',method: 'post'},

    'GetSubMeetingList': { path: 'meeting-micro/user-end/sub-meeting/get',method: 'post'},

    'GetHotelList': { path: 'meeting-micro/user-end/hotel/get',method: 'post'},

    'GetHotelRoomList': { path: 'meeting-micro/user-end/hotel-room/get',method: 'post'},

    'CreateOrder': { path: 'order-micro/user-end/order',method: 'post'},
    'GetOrderList': { path: 'order-micro/user-end/order/get',method: 'post'},
    'DeleteOrder': { path: 'order-micro/user-end/order/:ID', method: 'delete'},
    'UpdateOrder': { path: 'order-micro/user-end/order', method: 'put'},
    'UpdateOrderInfo': { path: 'order-micro/user-end/order-info',method: 'put'},
    'GetMeetingPreOrder':{ path: '/order-micro/user-end/order/pay', method: 'post'},
    'GetHotelPreOrder':{ path: '/order-micro/user-end/hotel-order/pay', method: 'post'},
    'HotelOrderRefund':{ path: '/order-micro/user-end/hotel-order/refund', method: 'post'},
    'GetHotelOrderList': { path: 'order-micro/user-end/hotel-order/get',method: 'post'},
    'UserUpdateHotelOrder': { path: 'order-micro/user-end/hotel-order/edit',method: 'post'},


    'GetInvoiceUrl':{ path: '/order-micro/user-end/invoice/get-url', method: 'post'},
    'GetMyInvoiceList':{ path: '/order-micro/user-end/invoice/get-my-list', method: 'post'},
    'GetInvoiceInfo':{ path: '/order-micro/user-end/invoice/get-yongyou', method: 'post'},
    'InvoiceApplyYongyou':{ path: '/order-micro/user-end/invoice/apply/yongyou', method: 'post'},
    'GetInvoiceUrlThirdPart':{ path: '/order-micro/user-end/invoice/get-url-third-part', method: 'post'},

    'GetTicketList': { path: 'order-micro/user-end/ticket/get',method: 'post'},

    'UpdateOrderMeetingReceipt': { path: 'order-micro/user-end/order-meeting-receipt',method: 'put'},
    'GetOrderMeetingReceiptList': { path: 'order-micro/user-end/order-meeting-receipt/get',method: 'post'},

    'GetOrderMeetingCertificateList': { path: 'order-micro/user-end/order-meeting-certificate/get',method: 'post'},

    'GetCommitteeList': { path: 'membership-micro/user-end/committee/get',method: 'post'},
    'SearchCommittee' : { path: 'membership-micro/user-end/committee/search',method: 'post'},

    'GetMemberUserList': { path: 'membership-micro/user-end/member-user/get',method: 'post'},

    'CreateMemberUserOrder': { path: 'membership-micro/user-end/member-user-order',method: 'post'},
    'GetMemberUserOrderList': { path: 'membership-micro/user-end/member-user-order/get',method: 'post'},
    'DeleteMemberUserOrder': { path: 'membership-micro/user-end/member-user-order/:ID', method: 'delete'},
    'GetMemberUserOrderPrePay':{ path: '/membership-micro/user-end/member-user-order/pay', method: 'post'},
    'MemberUserOrderFakeSuccess':{ path: '/membership-micro/user-end/member-user-order/fakesuccess', method: 'post'},
}